<template lang="pug" src="./block-row-section.pug"></template>

<script>
export default {
  props: ['props']
  // computed:{
  //   id(){
  //   }
  // },
  // created () {
  //   const whyChooseUs = this.$router.options.routes.find(({name}) => name === 'why choose us').children
  //   const rows = document.getElementsByClassName('block-row-section__row')
  //   const applyId = (item, i) => {
  //     console.log(item, i)
  //     item.id = idList[i]
  //     return item
  //   }
  //   Array.prototype.forEach.call(rows, applyId)
  // }
  // computed () {
  //   something () {
  //     console.log(this.$el)
  //   }
  // }
}
</script>



// WEBPACK FOOTER //
// block-row-section.vue?7216fdb4